import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap-5';

import { tagProps } from './tag_table';
import { map } from 'lodash';

export default function DeleteTagsModal({ modalDisplay, selectedTags, onCloseModal, onDeleteTags }) {
  const setSelectableTags = () => {
    return map(selectedTags, tag => (
      <div key={tag.id}>
        <p><strong>"{tag.name}"</strong></p>
      </div>
    ));
  };

  const renderTagForm = () => {
    return (
      <div className="form-group">
        <p>
          Delete the following tags?
        </p>
        <div className="form-input-container">
          {setSelectableTags()}
        </div>
      </div>
    );
  };

  const renderTagFooter = () => {
    return (
      <div>
        <button className="btn btn-ghost" name="cancel" onClick={onCloseModal}>
          Cancel
        </button>
        <button
          className="btn btn-destructive"
          disabled={selectedTags.length === 0}
          name="delete"
          onClick={onDeleteTags}
        >
          Delete Tags
        </button>
      </div>
    );
  };

  return (
    <Modal
      name="tag-form-modal"
      show={modalDisplay}
      onHide={onCloseModal}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Delete Tags
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {renderTagForm()}
        </div>
        <div className="mt-2">
          {renderTagFooter()}
        </div>
      </Modal.Body>
    </Modal>
  );
}

DeleteTagsModal.propTypes = {
  modalDisplay: PropTypes.bool.isRequired,
  selectedTags: PropTypes.arrayOf(tagProps).isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onDeleteTags: PropTypes.func.isRequired
};
